import React from 'react';
import AppsContainer from '@tenant/core/AppsContainer';
import { Box, Breadcrumbs, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { ROUTE_STRING } from 'constants/RouteString';
import AuditLogTable from './components/AuditLogTable';

// Portion A (developer-portal-audit-read-ui) — in-portal FE view over the existing internal
// GET /api/audit-log (Wave 1). Routed shell mirrors appInstance/List.js and pipelines/List.js;
// list/filter/paging logic lives in AuditLogTable. Gated on AUDIT_READ in ./index.js.
const ListAuditLog = () => {
  return (
    <AppsContainer
      fullView
      title={
        <Breadcrumbs aria-label='breadcrumb'>
          <Typography color='text.primary'>Developer</Typography>
          <Typography color='text.primary'>
            <Link to={ROUTE_STRING.AUDIT_LOG.LIST}>Audit Log</Link>
          </Typography>
        </Breadcrumbs>
      }
    >
      <Box
        sx={{
          '& .MuiDataGrid-root': {
            borderLeft: 0,
            borderRight: 0,
            borderTop: 0,
            borderRadius: 0,
          },
        }}
      >
        <AuditLogTable />
      </Box>
    </AppsContainer>
  );
};

export default React.memo(ListAuditLog);
